import { FC } from "react";
import { useTranslation } from "../../../contexts/useTranslation";

interface ThreadClosedMessageProps {
  onStartNewConversation: () => void;
}

const ThreadClosedMessage: FC<ThreadClosedMessageProps> = ({ onStartNewConversation }) => {
  const { translate } = useTranslation();

  return (
    <div className="px-4 pb-4 pt-4 text-center text-lastbot-on-surface border-t">
      <div className="text-sm">{translate("the_conversation_has_ended")}</div>
      <button
        type="button"
        onClick={onStartNewConversation}
        className="text-xs mt-1 underline cursor-pointer"
        data-testid={`thread-closed-start-new-conversation`}
      >
        {translate("start_new_conversation")}
      </button>
    </div>
  );
};

export default ThreadClosedMessage;
